import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";

interface Office {
  code: string;
  url: string;
}

const OfficeRedirect: React.FC = () => {
  const { city, office } = useParams<{ city: string; office: string }>();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchOfficeUrl = async () => {
      try {
        const response = await fetch(`/cities/${city}/offices`);
        if (!response.ok) {
          throw new Error("Failed to fetch office data");
        }
        const data = await response.json();
        const matchingOffice = data.offices.find(
          (o: Office) => o.code === office
        );

        if (matchingOffice) {
          window.location.href = matchingOffice.url;
        } else {
          console.error(`No matching office found for code: ${office}`);
          navigate(`/${city}`, { replace: true });
        }
      } catch (error) {
        console.error("Error fetching office data:", error);
        navigate(`/${city}`, { replace: true });
      } finally {
        setIsLoading(false);
      }
    };

    fetchOfficeUrl();
  }, [city, office, navigate]);

  if (isLoading) {
    return <div>Redirecting...</div>;
  }

  return null;
};

export default OfficeRedirect;
